import React, { PureComponent } from 'react';
import { NavLink as ReactRouterNavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

class ReactNavLink extends PureComponent {
  render() {
    const { className, to, handleClick, ...rest } = this.props;

    if (typeof to === 'string' && /^(?:https?:)?\/\//i.test(to)) {
      return (
        <a
          className={className}
          href={to}
          target={'_blank'}
          rel="noopener noreferrer"
          {...rest}
        />
      );
    } else {
      const toToJs = to && to.toJS ? to.toJS() : to;

      return (
        <ReactRouterNavLink
          className={className}
          to={toToJs || ''}
          {...rest}
          onClick={() => handleClick()}
        />
      );
    }
  }
}

ReactNavLink.defaultProps = {
  handleClick: () => null,
};

ReactNavLink.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  state: PropTypes.object,
  handleClick: PropTypes.func,
};

export default ReactNavLink;
